import React from "react";
import PropTypes from "prop-types";
import { Field } from "formik";
import { Checkbox as CheckboxUI } from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";

function CheckboxField({ fieldName, readOnly, onChange, ...rest }) {
    const onChangeHandler = (event, field, form) => {
        field.onChange(event);
        if (onChange && typeof onChange === "function") {
            onChange(field.name, event && event.target && event.target.checked, form);
        }
    };

    return (
        <Field name={fieldName}>
            {({ field, form }) => (
                <FormControlLabel
                    control={
                        <CheckboxUI
                            checked={Boolean(field.value)}
                            {...field}
                            {...rest}
                            onChange={(event, checked) => onChangeHandler(event, field, form)}
                            {...(readOnly ? { onChange: undefined, color: "default" } : { color: "primary" })}
                        />
                    }
                    label={rest.label}
                />
            )}
        </Field>
    );
}

CheckboxField.propTypes = {
    fieldName: PropTypes.string.isRequired,
    margin: PropTypes.string,
    readOnly: PropTypes.bool,
    onChange: PropTypes.func,
};

CheckboxField.defaultProps = {
    margin: "normal",
    readOnly: false,
    onChange: undefined,
};

export default CheckboxField;
